import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ChatFragmentDoc } from '../../../../../features/messages/graphql/fragments/generated/Chat';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetAllAiChannelsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ChannelsFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type GetAllAiChannelsQuery = { channels: { edges?: Array<{ node: { id: string, name: string, createdAt: string } }> | null } };


export const GetAllAiChannelsDocument = /*#__PURE__*/ gql`
    query getAllAIChannels($filters: ChannelsFilters, $first: Float) {
  channels(filters: $filters, first: $first) {
    edges {
      node {
        ...Chat
      }
    }
  }
}
    ${ChatFragmentDoc}`;

export function useGetAllAiChannelsQuery(options?: Omit<Urql.UseQueryArgs<GetAllAiChannelsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllAiChannelsQuery, GetAllAiChannelsQueryVariables>({ query: GetAllAiChannelsDocument, ...options });
};